/**
 * 
 */
import { BuildingShort } from '@n3/ng-api-common';
import { Capacity } from '@n3/ng-api-common';
import { Address } from '@n3/ng-api-common';
import { ClassifierShort } from '@n3/ng-api-common';
import { Room } from './room.model';
import { PlaceEquipment } from './placeEquipment.model';
export class Building extends BuildingShort {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public capacity: Capacity; /**/
    public address: Address; /**/
    public type: ClassifierShort; /**/
    public terrain: ClassifierShort; /**/
    public rooms: Room[]; /*Помещения*/
    public equipment: PlaceEquipment[]; /*Оснащение*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.capacity = new Capacity(json.capacity);
        this.address = new Address(json.address);
        this.type = new ClassifierShort(json.type);
        this.terrain = new ClassifierShort(json.terrain);
        this.rooms = [];
        if (json.rooms) {
          for (const i in json.rooms) {
            if ( json.rooms.hasOwnProperty( i ) ) {
                this.rooms.push(new Room(json.rooms[i]));
            }
          }
        }
        this.equipment = [];
        if (json.equipment) {
          for (const i in json.equipment) {
            if ( json.equipment.hasOwnProperty( i ) ) {
                this.equipment.push(new PlaceEquipment(json.equipment[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
